import { defaultPagination } from "../../../reducers/collectionPointReducer";
import { cleanUpInventorySheetList, setInventorySheetListPagination } from "../../../reducers/inventorySheetReducer";
import { AppDispatch } from "../../../store";

export const resetInventorySheet = (dispatch: AppDispatch): void => {
  dispatch(cleanUpInventorySheetList());
  dispatch(setInventorySheetListPagination(defaultPagination));
};
